// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__7VZ1-","badge__icon":"Badge_badge__icon__A3id-","badge__text":"Badge_badge__text__B4E9-","badge__number":"Badge_badge__number__-nQBd"};